<template>
  <div class="imgTextbox">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="内容" name="1">
        <el-alert title="添加导航(最少1个，最多6个)" type="success" :closable="false">
        </el-alert>
        <el-card shadow="hover" v-for="(item, index) in data.imgTextList" :key="index">
          <el-button class="close_btn" icon="el-icon-close" circle size="mini" @click="handleDel(index)"></el-button>
          <div class="cardList">
            <div style="margin-right: 8px">
              <div class="preImg" @click="handImgUpd(index)">
                <img v-if="item.src" :src="item.src" />
                <img v-else src="../../assets/image-upload.jpg" />
              </div>
              <p class="tip">最佳尺寸：500x400px</p>
            </div>
            <div class="dropdownBox">
              <el-input type="text" maxlength="6" show-word-limit id="name" v-model="item.name" />
              <el-dropdown @command="handleLinkItem" placement="bottom-start">
                <span class="el-dropdown-link">
                  {{ item.link }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx" :command="`${link.title}#${link.page}?${index}`">
                    {{ link.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-card>
        <el-button type="primary" style="width: 100%;" size="small" @click="handleAdd">添加导航</el-button>
      </el-collapse-item>
      <el-collapse-item title="内容样式" name="2">
        <ul class="settingUl">
          <li>
            <span>图片间隔</span>
            <el-radio-group v-model="data.conStyle.tupianjg" size="mini">
              <el-radio-button label="默认">默认</el-radio-button>
              <el-radio-button label="自定义">自定义</el-radio-button>
            </el-radio-group>
          </li>
          <li v-if="data.conStyle.tupianjg === '自定义'">
            <span>间隔距离</span>
            <div>(px)</div>
          </li>
          <li v-if="data.conStyle.tupianjg === '自定义'">
            <div style="width: 100%;">
              <el-slider v-model="data.conStyle.space" :max="30" :min="0" show-input>
              </el-slider>
            </div>
          </li>
          <li>
            <span>文字大小({{ data.conStyle.titleSize }})</span>
            <el-radio-group v-model="data.conStyle.titleSize" size="mini">
              <el-radio-button label="12">小</el-radio-button>
              <el-radio-button label="14">中</el-radio-button>
              <el-radio-button label="16">大</el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <span>标题颜色</span>
            <el-color-picker v-model="data.conStyle.titleColor"></el-color-picker>
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="组件样式" name="3">
        <comSetting :infoItme="data.infoItme" />
      </el-collapse-item>
    </el-collapse>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>
<script>
import imgPre from '../../components/uploadImg/imgPre'
import draggable from 'vuedraggable'
import comSetting from '../comSetting'

export default {
  name: 'imgTextSetting',
  components: { imgPre, draggable, comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      uploadShow: false,
      activeNames: ['1'],
      idx: 0
    }
  },
  created () {
    console.log(this.data, 'ceshi jsdhk ')
  },
  methods: {
    handImgUpd: function (index) {
      this.idx = index
      this.uploadShow = true
    },
    handleImg: function (data) {
      this.data.imgTextList[this.idx].src = data.url
      this.uploadShow = false
    },
    handleAdd: function () {
      if (this.data.imgTextList.length > 5) {
        return this.$message({
          message: '图文导航最多添加6个',
          type: 'warning'
        })
      }
      this.data.imgTextList.push({
        src: '',
        name: '图文导航'
      })
    },
    handleDel: function (index) {
      this.data.imgTextList.splice(index, 1)
    },
    handleLinkItem (command) {
      const idx = command.indexOf('?')
      const idx1 = command.indexOf('#')
      var before = command.substring(0, idx)
      var after = command.substring(idx + 1)
      const pagetit = before.substring(0, idx1)
      const page = before.substring(idx1 + 1)

      this.data.imgTextList[Number(after)].link = pagetit
      this.data.imgTextList[Number(after)].page = page
    }
  }
}
</script>
<style scoped>
.imgTextbox {
  padding: 0 20px;
}

.el-card {
  margin-bottom: 15px;
  background-color: #f9fafc;
  position: relative;
}

.close_btn {
  position: absolute;
  right: 0;
  top: 0;
}

.el-card .cardList {
  display: flex;
  justify-content: space-around;
}

.dropdownBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cardList .preImg {
  width: 64px;
  height: 64px;
  position: relative;
  border-radius: 12px;
  cursor: pointer;
  line-height: 64px;
  text-align: center;
}

.cardList .preImg img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.cardList .preImg:hover::after {
  content: "点击上传";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/imgText/imgTextSetting.vue